export const GET_CLIENT_NOTIFICATIONS_REQUEST =
  "GET_CLIENT_NOTIFICATIONS_REQUEST";
export const GET_CLIENT_NOTIFICATIONS_RESPONSE =
  "GET_CLIENT_NOTIFICATIONS_RESPONSE";

export const SET_CLIENT_NOTIFICATION_SEEN = "SET_CLIENT_NOTIFICATION_SEEN";
export const REPLACE_CLIENT_NOTIFICATION = "REPLACE_CLIENT_NOTIFICATION";

export const GET_CLIENT_DROPDOWN_NOTIFICATIONS_REQUEST =
  "GET_CLIENT_DROPDOWN_NOTIFICATIONS_REQUEST";
export const GET_CLIENT_DROPDOWN_NOTIFICATIONS_RESPONSE =
  "GET_CLIENT_DROPDOWN_NOTIFICATIONS_RESPONSE";

export const SET_CLIENT_UNSEEN_NOTIFICATIONS_COUNT =
  "SET_CLIENT_UNSEEN_NOTIFICATIONS_COUNT";

export const ADD_CLIENT_PUSH_NOTIFICATION = "ADD_CLIENT_PUSH_NOTIFICATION";
